import { Stack, Typography, Box, useMediaQuery } from "@mui/material";
import { motion } from "framer-motion";
import { ReactComponent as Lines1 } from "../../images/svg/lines1Anim.svg";
import "../../images/svg/lines1Anim.css";

const Skills = () => {
    return (
        <Stack
            component={motion.div}
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ ease: "easeOut", duration: 0.8 }}
            sx={{
                width: "100%",
                position: "relative",
            }}
            spacing={4}
        >
            <Box>
                <Typography variant="h4" fontWeight={700} color="white" gutterBottom>
                    What I do
                </Typography>
                <Typography variant="body1" color="rgba(255, 255, 255, 0.7)" sx={{ lineHeight: 1.8 }}>
                    I build high-performance web applications and services. My primary focus is on 
                    <span style={{ color: '#22d3ee' }}> Javascript & Typescript</span> ecosystem, 
                    crafting seamless digital experiences with modern tools.
                </Typography>
            </Box>

            <Stack spacing={3}>
                <Box>
                    <Typography variant="subtitle1" color="white" fontWeight={600} gutterBottom>
                        Stack
                    </Typography>
                    <Typography variant="body2" color="rgba(255, 255, 255, 0.5)">
                        React, Next.js, Express, Fastify, MySQL, Flutter, Playwright.
                    </Typography>
                </Box>
                <Box>
                    <Typography variant="subtitle1" color="white" fontWeight={600} gutterBottom>
                        Currently
                    </Typography>
                    <Typography variant="body2" color="rgba(255, 255, 255, 0.5)">
                        Software Engineer at 
                        <Typography 
                            component="a" 
                            href="https://little.africa/" 
                            sx={{ color: '#818cf8', ml: 0.5, textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
                        >
                            Little
                        </Typography>
                    </Typography>
                </Box>
            </Stack>
        </Stack>
    );
};

export default Skills;
